import React from 'react';
import styled from '@emotion/styled';
import XLoader from '@nexus/lib-react/dist/core/Loading/XLoader';

const LoaderContainer = styled.div`
  min-width: 150px;
  min-height: 230px;
  display: grid;
  place-content: center;
`;

function Loader() {
  return (
    <LoaderContainer data-testid="loader" data-cy="loader">
      <XLoader />
    </LoaderContainer>
  );
}

export default Loader;
